import { render, staticRenderFns } from "./ProviderHeaderInfo.vue?vue&type=template&id=fab748a4&scoped=true"
import script from "./ProviderHeaderInfo.vue?vue&type=script&lang=js"
export * from "./ProviderHeaderInfo.vue?vue&type=script&lang=js"
import style0 from "./ProviderHeaderInfo.vue?vue&type=style&index=0&id=fab748a4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab748a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fab748a4')) {
      api.createRecord('fab748a4', component.options)
    } else {
      api.reload('fab748a4', component.options)
    }
    module.hot.accept("./ProviderHeaderInfo.vue?vue&type=template&id=fab748a4&scoped=true", function () {
      api.rerender('fab748a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/_components/ProviderHeaderInfo.vue"
export default component.exports